<script setup lang="ts">
const props = defineProps<{
  status?: 'primary' | 'secondary'
  disabled?: boolean
}>()

const statusClassMap = {
  primary:
    'w-full cursor-pointer rounded-lg bg-blue-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 focus:outline-none disabled:cursor-not-allowed',
  secondary:
    'w-full cursor-pointer rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-sm font-medium text-gray-900 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 focus:outline-none disabled:cursor-not-allowed',
}
const className = statusClassMap[props.status ?? 'primary']
</script>
<template>
  <button :class="className" v-bind="$attrs" :disabled="props.disabled">
    <slot />
  </button>
</template>
